import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { NetworkAssetListDataIn } from 'src/app/models/network-asset.model';
import { NetworkAssetTypes } from 'src/app/enums/network-asset-types.enum';
import { LogicalTreeRequest } from '../models/logical-tree-request.model';

@Injectable({
  providedIn: 'root'
})
export class NetworkAssetService {

  private pathApi = this.config.setting['pathApi'] + "networkAssets/";
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private config: AppConfig) {}
  
  getNetworkAssetCounts(dataIn: NetworkAssetListDataIn): Observable<any> {
    return this.http.post(`${this.pathApi}getNetworkAssetCounts`, dataIn, { observe: 'response' });
  }

  getLogicalTree(request: LogicalTreeRequest): Observable<any> {
    return this.http.post<any>(`${this.pathApi}getLogicalTree`, request, { observe: 'response' });
  }
  getNetworkAssetOptions(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getMoreNetworkAssets`, dataIn, { observe: 'response' });
  }

  getTaggedDtsForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getTaggedDtsForSelect`, { headers: this.headers, observe: 'response' });
  }
}
